export let dkMessages={
  "privacy_policy_and_terms_of_use":"Politik om databeskyttelse og vilkår for brug",   // todo.1
  "privacy_confirm_text":"Vi har opdateret vores politik om databeskyttelse og vilkår for brug . For at kunne fortsætte med at bruge Easyview, bedes du læse og acceptere alle vilkårene.",   // todo
  "privacy_confirm_disagree":"Uenig",
  "privacy_confirm_accept":"Accepter",

  "title":"EasyView Personal",   // todo
  "title1":"EasyView Pro",   // todo
  "user":"E-mail",
  "password":"Adgangskode",
  "remember":"Husk mig",
  "forget":"Glemt adgangskode?",
  "sign in":"Log på",
  "login":"Login",   // todo
  "sign up now":"Tilmeld dig nu",
  "apply":"Ansøg om en konto",
  "contact us":"Kontakt os",
  "Privacy Policy":"Politik om databeskyttelse",
  "Terms of Use":"Vilkår for brug",
  "copyright":"Copyright © 2021 Medtrum Technologies Inc. Alle rettigheder forbeholdes.",

  "chooseLang":"Vælg dit land eller sprog",
  "asia":"Asia Pacific",   // todo
  "europe":"Europa",
  "middleEast":"Middle East",   // todo

  "applyHcp":"Ansøg om en HCP-konto ",
  "sign up":"Tilmeld dig",
  "Patient":"Patient",
  "Caregiver":"pårørende",
  "Email":"E-mail",
  "Mobile":"Mobil",
  "Enter email":"Indtast e-mailadresse",
  "Enter mobile":"Indtast mobilnummer",
  "Verification":"Bekræftelseskode",
  "Invitation":"Invitation code",   // todo
  "full name":"Indtast dit fulde navn",
  "Enter pass":"Enter password",   // todo
  "org":"Organisation",
  "Register":"Register",   // todo
  "send":"Send",
  "createAccount":"Create Account",   // todo
  "agree":"I have read and agree to the ",   // todo
  "privacy":" Medtrum privacy policy  ",   // todo
  "and":"and ",   // todo
  "use":"terms of service.",   // todo
  "errtip1-1":"Du skal indtaste en gyldig e-mailadresse, ",   // todox
  "errtip1-2":"som bliver dit Medtrum-brugernavn.",   // todox
  "errtip2":"Please enter a valid mobile number.",   // todo
  "errtip3":"Bekræftelseskode er forkert",
  "errtip4":"Incorrect invitation code.",   // todo
  "errtip5":"Brugernavn er forkert",
  "errtip6":"Your password must have 8 or more characters.",   // todo
  "errtip7":"Indtast venligst din organisation",

  "errp1":"Adgangskoden skal indeholde mindst 3 typer af følgende tegn:",   // todox
  "errp2":"store bogstaver, små bogstaver, tal og specialtegn.",   // todox
  "errp3":"Adgangskoden skal være på mellem 6 og 20 tegn.",
  "errp4":"Adgangskoden skal være anderledes end brugernavnet.",
  "errp5":"En adgangskode med 3 tal efter hinanden er ugyldig (f.eks.: 123, 321).",
  "errp6":"En adgangskode med 3 bogstaver efter hinanden er ugyldig (f.eks.: abc, cba).",
  "errp7":"Adgangskoden må ikke indeholde mellemrum.",


  "Find account":"Hent din adgangskode.",
  "Enter username":"Indtast dit brugernavn.",
  "Next":"Næste",
  "Cancel":"Annuller",
  "Back":"Tilbage",
  "Enter veri":"Enter verification code",   // todo
  "Verify notice":"Find den bekræftelseskode, der blev sendt i en e-mail.",
  "Create new":"Opret en ny adgangskode",
  "Create new notice":"Opret en ny adgangskode. Adgangskoden skal indeholde 6 eller flere tegn.",
  "New pass":"Ny adgangskode",
  "Completed":"Fuldført",
  "Created":"Ny adgangskode er oprettet.",
  "Login Now":"Log på nu",

  "Delete":"Slet",
  "New Patient":"Ny patient",
  "Add Patient":"Tilføj patient",
  "Filter":"Filter",
  "Name":"Navn",
  "Gender":"Køn",
  "Age":"Alder",
  "Type":"Type",
  "Duration":"Varighed",
  "Connections":"Kontoopretter",
  "UploadTime":"Overførselstid",
  "Year":"år",   // todox
  "Years":"år",   // todox
  "Month":"måneder",   // todox
  "Month2":"Måned",
  "Months":"måneder",   // todox
  "Invite":"Inviter",
  "Invited":"Inviteret",
  "All":"Alle",
  "Female":"Kvinde",
  "Male":"Mand",
  "Not Set":"Not Set",   // todo
  "Type 1":"Type 1",
  "Type 2":"Type 2",
  "Gestational":"Graviditet",
  "Prediabetes":"Prædiabetes",
  "LADA":"Type 1.5 LADA",
  "Apply":"Anvend",
  "disUn":"Diabetes type ikke angivet",
  "ageUn":"Alder ikke angivet",
  "genUn":"Køn ikke angivet",
  "addP":"Tilføj patient",
  "newP":"Ny patient",
  "findP":"Find patient",

  "GDRNF":"Ikke angivet",
  "GDRF":"Kvinde",
  "GDRM":"Mand",
  "女":"Mand",

  "DBTNF":"Ikke angivet",
  "DBT1":"Type 1",
  "DBT2":"Type 2",
  "DBTLADA":"Type 1.5 LADA",
  "DBTPRE":"Prædiabetes",
  "DBTGEST":"Graviditet",
  "前期":"beFore",   // todo
  "beFore":"beFore",   // todo
  "MODY":"Mody",   // todo

  "No selection":"No selection",   // todo
  "unspecif":"unspecified",   // todo
  "register":"Patient",
  "hcp":"Kliniker",

  "BG":"BS",
  "CARB":"Kulhydrater",
  "INS":"Injektion",
  "EXR":"Motion",
  "OTR":"Andet",
  "HBA1C":"HbA1c",
  "DOSE":"DOSE",   // todo
  "URINEK":"Urinketon",
  "HEL":"HEL",   // todo
  "OTR1":"Andet",
  "Loading":"Indlæser",

  "home":"Hjem",
  "pID":"Patient-ID",
  "fullName":"Fulde navn",
  "gender":"Køn",
  "height":"Højde",
  "weight":"Vægt",
  "cm":"cm",
  "kg":"kg",
  "birthday":"Fødselsdato",
  "disType":"Type af diabetes",
  "disDate":"Dato for diagnose",
  "Address":"Adresse",
  "Postcode":"Postnummer",
  "Inpatient":"Indlagt patient",
  "Yes":"Ja",
  "No":"Nej",
  "Pno":"Patientnr.",
  "Bno":"Sengenr.",
  "create":"Opret",
  "Telephone":"Telefon",

  "enterU":"Indtast brugernavn (e-mail)",
  "search":"Søg",
  "noU":"Brugernavn skal angives.",
  "searchR":"Søgeresultater",
  "uername":"Brugernavn",
  "alias":"Alias",
  "remove":"Fjern",
  "viewG":"Vis grafer",
  "sendR":"Send anmodning",
  "rSent":"Din anmodning er afsendt.",
  "cancelR":"Slet anmodning",

  "VcodeTip1":"Didn’t receive it? Please wait for a few minutes and",   // todo
  "VcodeTip2":"try again.",   // todo
  "VcodeTip3":"We just sent a code to ",   // todo
  "Entercode":"Indtast kode",
  "Getcode":"Få kode",

  "messages":"Meddelelser",
  "profile":"Profil",
  "sign out":"Log af",
  "changeP":"Skift adgangskode",
  "connection":"Forbindelser",

  "myP":"Min profil",
  "Portrait":"Profilbillede",
  "Profession":"Erhverv",
  "DPRONF":"Ikke angivet",
  "DPROENDOCRIN":"Endokrinolog",
  "DPRODIABTRA":"Diabetesunderviser",
  "DPRONURSE":"Sygeplejerske",
  "DPRODIATIT":"Diætist",
  "DPROOTR":"Andre sundhedspersoner",
  "Organization":"Organisation",
  "Bio":"Bio",
  "save":"Gem",
  "oldPa":"Gammel adgangskode ",
  "newPa":"Ny adgangskode",
  "RePa":"Indtast adgangskode igen",
  "forgetY":"Glemt din adgangskode?",
  "applyM":"Anvend",
  "oldErr":"Det gamle Adgangskode er ikke korrekt.",
  "EntTheSame":"Indtast den nye Adgangskode igen.",
  "EnterOld":"Enter the old Password!",   // todo

  "pList":"Patientliste",
  "connections":"Forbindelser",
  "settings":"Indstillinger",
  "monitor":"Overvåg",
  "graphs":"Rapporter",
  "events":"Hændelser",
  "records":"Overblik",
  "qPrint":"Hurtig udskrivning",

  "sensorIn":"Sensoroplysninger",
  "timeOfLaRead":"Tidspunkt for den sidste sensormåling",
  "tranSn":"Transmitters SN",
  "status":"Status",
  "sensorLife":"Resterende sensorlevetid",
  "lastSenorRead":"Seneste sensormåling",
  "TranBattery":"Transmitterbatteri",
  "sg":"SG",
  "alert":"Advarsel",
  "target":"Mål",
  "hypo":"Hypo",
  "sensorGlucose":"Sensorglukose",
  "calib":"Kalibrering",
  "newSen":"Ny sensor",
  "warm":"Opvarmning",
  "InsulinPump":"Insulinpumpe",
  "timeOfLaPump":"Tidspunkt for de sidste pumpedata",
  "pumpSN":"Pumpebases SN",
  "ReserviorLife":"Resterende levetid for reservoir-patch",
  "InsulinLeft":"Insulin tilbage",
  "basal":"Basal",
  "bolus":"Bolus",
  "totalBasal":"Total daglig basal",
  "lastBolus":"Sidste bolus",
  "activeInsulin":"Aktivt insulin",
  "totalBolus":"Total daglig bolus",
  "tampBasal":"Midl. basal",
  "normalBolus":"Normal Bolus",
  "extendBolus":"Forlænget Bolus",
  "manualStop":"Manuelt Stop",
  "autoStop":"Automatisk Stop",
  "auto suspend":"Automatisk Stop",
  "stop":"Tilførselsstop",
  "newPatch":"Ny patch",
  "tempBasal":"Midl. Basal",
  "N":"N",
  "E":" F",
  "CN1":"KN",
  "CE":" KF",

  "staticSettings":"Rapport Indstillinger",
  "dataSource":"Data, der skal vises",
  "unit":"Enhed:",   // todox
  "glucoseTarget":"Glukose Måleområde",
  "overall":"Samlet",
  "Hypoglycemia":"Hypoglykæmi",
  "timePeriod":"Tidsperiode",
  "postMeal":"Analyse efter måltid",
  "Breakfast":"Morgen",
  "Lunch":"Frokost",
  "Dinner":"Middag",
  "night":"Nat",
  "Before":"Før",
  "After":"Efter",
  "Low":"Lav",
  "High":"Høj",
  "From":"Fra",
  "To":"Til",
  "Hours":"Timer",   // todox
  "Reset":"Gendan standarder",
  "RealTime":"Realtid",
  "uploaded":"Overført",
  "sensor":"Sensor",
  "pdmSN":"PDM SN",
  "startTime":"Starttidspunkt",
  "endTime":"Sluttidspunkt",
  "uploadTime":"Time of upload",   // todo
  "pdm":"PDM",
  "Uploaded":"Overført",
  "Patch Pump":"Patch Pumpe",
  "overLapp":"Sessioner overlapper hinanden",
  "showAlert":"Vis advarsler",

  "dashboard":"Dashboard ",
  "dboard_glucose_statistics":"Glucose Statistics",   // todo
  "dboard_glucose":"BS",
  "dboard_cgm":"CGM",
  "dboard_insulin":"Insulin",
  "dboard_carbs":"Kulhydrater",
  "dboard_exercise":"Motion",
  "dboard_glucose_avg":"Gennemsnit",
  "dboard_cgm_avg":"Gennemsnit",
  "dboard_insulin_avg":"Gennemsnitlig daglig dosis",
  "dboard_carbs_avg":"Gennemsnitlige kulhydrater/dag",
  "dboard_exercise_avg":"Gennemsnitlig tid/dag",
  "dboard_sd":"SD",
  "dboard_num":"#",
  "dboard_num_days":"# dage",   // todox
  "dboard_statistics":"Statistik",
  "dboard_BG":"BS",
  "dboard_BG_calibration":"BS/kalibrering (pr. dag)",   // todox
  "dboard_SG":"SG",
  "dboard_AUC_high":"AUC høj >",   // todox
  "dboard_AUC_low":"AUC lav <",   // todox
  "dboard_highest_value":"Højeste værdi",
  "dboard_lowest_value":"Laveste værdi",

  "dboard_pump":"Pumpe",
  "dboard_avg_daily_dose":"Gennemsnitlig daglig dosis",
  "dboard_SD":"SD",
  "dboard_daily_basal":"Daglig basal",
  "dboard_daily_bolus":"Daglig bolus",
  "dboard_avg_bolus_num":"Gennemsnitligt antal boli pr. dag",
  "dboard_avg_suspend_time":"Gennemsnitlig stoppet tid",
  "dboard_avg_reservoir_usage":"Gennemsnitlig reservoirbrug",
  "dboard_days":"dage",   // todox

  "dboard_manual_bolus":"Manuel bolus (mængde/antal pr. dag)",
  "dboard_normal":"-Normal",
  "dboard_extend":"-Forlænget",
  "dboard_combo":"-Kombi",

  "dboard_bolus_calculator":"Bolusguide (mængde/antal pr. dag)",
  "dboard_food_bolus":"-Måltidsbolus",
  "dboard_corr_bolus":"-Korr.bolus",
  "dboard_override_add":"-Forøg (+)",
  "dboard_override_sub":"-Formindsk (-)",

  "dboard_report":"Dashboard Rapport ",

  "daily":"Daglig oversigt",
  "date":"Dato",
  "print":"Udskriv",
  "carbs":"Kulhydrater",
  "exercise":"Motion",
  "heavy":"Hård",
  "Medium":"Mellem",
  "Light":"Let",
  "dailyReport":"Daglig Oversigts Rapport",
  "devices":"Enheder",
  "tran":"Transmitter",
  "pumpBase":"Pumpebase",
  "HbA1c":"HbA1c",
  "statics":"Statistik",
  "glucose":"Glukose",
  "item":"Element",
  "BG1":"BS",
  "SG1":"SG",
  "avgSD":"Gns. (mmol/l)±SD",
  "avgSD1":"Gns±SD ",
  "min":"Min.",
  "max":"Maks.",
  "ofRead":"Antal aflæsninger",
  "ofHypo":"Antal hypo/varighed",   // todox
  "ofAlert":"Antal advarsler",
  "insulin":"Insulin",
  "insulin2":"Insulin",
  "totalDose":"Samlet daglig dosis",   // todox
  "foodBolus":"Kulhydratbolus",   // todox
  "Food+coor":"Food+corr",   // todo
  "calibBolus":"Korrektionsbolus",   // todox
  "durationStop":"Varighed af stop (min.)",   // todox
  "ofPumpAlert":"Antal pumpealarmer",
  "ofMeal":"Antal måltider",
  "totalExerTime":"Samlet motionstid",
  "exerNum":"Antal øvelser",
  "avgInten":"Gns. intensitet",
  "target1":"Mål",
  "high1":"Høj",
  "low1":"Lav",
  "BG Reading":"BS-aflæsninger",   // todox

  "dayByday":"Oversigt dag for dag",
  "dayBydayRe":"Oversigtsrapport dag for dag",   // todox
  "period":"Periode",

  "sensorOverlay":"Sensor Overblik",
  "set":"Indstil",
  "setPeriod":"Indstil periode",
  "Weekdays":"Hverdage",
  "Weekends":"Weekender",
  "Mon":"Man",
  "Tue":"Tir",
  "Wed":"Ons",
  "Thur":"Tor",
  "Thu":"Tor",
  "Fri":"Fre",
  "Sat":"Lør",
  "Sun":"Søn",
  "Average":"Gennemsnit",
  "sensorOlRe":"Sensor Overbliks Rapport ",
  "Avg":"Gns.",
  "±SD":"±SD",   // todox
  "ofhypo":"Antal hypo",
  "Everyday":"hver dag",

  "TrendAna":"Tendensanalyse",
  "TrendRe":"Tendens Analyse Rapport",
  "sensorGlu":"Sensorglukose ",   // todox
  "ofBGtest":"Antal BS-tests",
  "Basics":"Grundlæggende",
  "static":"Statistik",
  "Med":"Med",
  "med":"median",   // todo
  "Q1":"Q1",   // todo
  "Q3":"Q3",   // todo
  "Q11":"Q1",   // todo
  "Q31":"Q3",   // todo
  "IQR":"IQR",
  "SD":"SD",
  "CV":"CV",
  "SE1":"SE middel",
  "distri":"Distribution",   // todo
  "stab":"Stabilitet",
  "#high":"Antal høje",
  "#low":"Antal lave",
  "aucBelow":"AUC Below limit",   // todo
  "aucAbove":"AUC Above limit",   // todo
  "bgRead":"BS-aflæsninger",
  "total":"Avg Daily Total",   // todo
  "avg_daily_basal":"Avg Daily Basal",   // todo
  "avg_daily_bolus":"Avg Daily Bolus",   // todo
  "ofBolus":"Avg # of bolus/Day",   // todo
  "avgBolus":"Avg bolus(U)/Each",   // todo
  "Dura1":"Varighed (min.)",
  "Avg/Total":"Gns./samlet",
  "high":"Høj",
  "low":"Lav",
  "#hypo":"Antal hypo",
  "ofExer":"Antal øvelser",

  "logbook":"Logbog",
  "dailyTotal":"Daglig Total",
  "High Glucose":"Høj Glukose",
  "Low Glucose":"Lav Glukose",
  "No Active Patch":"Ingen aktiv Patch",
  "Missed Meal":"Mistet måltid",
  "Multiple BG Readings":"Flere BS-aflæsninger",
  "Stop Patch":"Stop Patch",
  "Others":"Andre",
  "Other Events":"Andre Begivenheder",
  "logRe":"Logbogs Rapport",

  "DeviceSetting":"Gennemgang af PDM Indstillinger",
  "Insulin Pump":"Insulinpumpe",
  "MaxBasalRate":"Maksimal basaldosis",
  "BasalPatterns":"Basalmønstre",
  "Selected Basal Pattern":"Valgt basalmønster",
  "Maximum Bolus":"Maks. bolus",
  "Combo/Extended Bolus":"Kombi/Forlænget bolus",
  "BG Reminder":"BS-påmindelse:",   // todox
  "Bolus Increment":"Bolusforøgelse",
  "Bolus Calculator":"Bolusguide",
  "Active Insulin Time":"Aktiv insulintid",
  "IC Ratios":"Kulhydrat-forhold ",   // todox
  "Insulin Sensitivity":"Insulinfølsomhed",
  "BG Target":"BS-mål",
  "Bolus Reminder":"Boluspåmindelse",
  "CGM":"CGM",
  "CGM System":"CGM-system",
  "Glucose Unit":"Glukoseenhed",
  "Glucose Limits":"Glukosegrænser",
  "Predicitive Alerts":"Forventede advarsler",
  "Rate Alerts":"Hastighedsadvarsler",
  "type":"Type",
  "time":"Tid",
  "data":"Data",
  "Rate":"Rate",   // todo
  "Calibration Reminder":"Påmindelse om kalibrering",
  "Calibration Repeat":"Gentagelse af kalibrering",
  "Snooze":"Snooze",
  "Audio Options":"Lydindstillinger",
  "Confidence Reminder":"Anvendelsesfeedback",
  "Backlight":"Baggrundslys:",   // todox
  "Sec":"sek.",
  "Alarm Clock":"Alarmur",
  "Patch Expiration":"Patch-udløb",
  "Sensor Expiration":"Sensorudløb",
  "Hourly Max":"Maks. pr. time",
  "Daily Max":"Dagligt maks.",
  "Low Reservoir":"Reservoir lavt",
  "Low Suspend":"Stop ved lav",
  "Predictive Low Suspend":"Stop før Lav",
  "Rise":"Stigning",
  "Fall":"Fald",
  "Auto Off":"Auto-sluk",
  "Standard":"Standard",
  "Exercise":"Motion",
  "Holiday":"Ferie",
  "ProgramA":"Mønster A",
  "ProgramB":"Mønster B",
  "--":"--",   // todo
  "Insulin":"Insulin",

  "SUSA":"Auto fra",
  "SUSHM":"Overstiger maks. tilførsel pr. 1 time",
  "SUSDM":"Overstiger maks. TDD",
  "SUSLSG":"Stop ved lav",
  "SUSPLSG":"Stop før Lav",
  "Pump Restarted":"Pumpe genstartet",
  "Meter BG Now":"Mål BS nu",
  "Sensor Exp in 2 Hours":"Sensorudløb om 2 timer",
  "Sensor Exp in 6 Hours":"Sensorudløb om 6 timer",
  "Sensor Exp in 30 Min":"Sensorudløb om 30 min.",
  "Sensor Calibration Error":"Fejl i sensorkal.",   // todox
  "Sensor Error":"Ingen målinger",

  "Device Settings Report":"Rapport med Enheds Indstillinger",
  "24h Total":"Døgntotal",
  "Device Settings at":"Enheds Indstillinger",   // todox
  "Start":"Start",
  "Combo/Ext Bolus":"Kombi/Forlænget bolus",
  "Time Format":"Tidsformat",
  "Device Options（CGM System)":"Enhedsindstillinger (CGM-system)",   // todox
  "Device Options（Insulin Pump)":"Enhedsindstillinger (insulinpumpe)",   // todox
  "Dispay Settings (Screen)":"Visningsindstillinger (skærm)",
  "Dispay Settings (Backlight)":"Visningsindstillinger (baggrundslys)",
  "Graph Range":"Grafområde",
  "Range":"Range",   // todo
  "Repeat":"Gentag",
  "Glucose Alerts":"Glukoseadvarsler ",
  "Alert Silence":"Advarsel Lydløs",

  "Create":"Opret",
  "Event Filter":"Begivenhedsfilter",
  "HbA1c1":"HbA1c",
  "Urine Ketone":"Urinketon",   // todox
  "Injection":"Injektion",
  "Other":"Andet",
  "Event Type":"Begivenhedstype",
  "Details":"Info",
  "Notes":"Bemærkninger",
  "Source":"Kilde",
  "edit":"Rediger",
  "Action":"Handling",
  "EventReport":"Begivenheds Oversigts Rapport",
  "By Date":"Efter dato",
  "By Category":"Efter kategori",
  "Event Summary":"Begivenheds Oversigt",
  "No data":"Ingen data",
  "No1":"Nej",
  "data1":"data",   // todo
  "#":"#",
  "BG Summary":"BS-oversigt",
  "Carbs Summary":"Kulhydratoversigt",
  "Injection Summary":"Injektionsoversigt",
  "Exercise Summary":"Motionsoversigt",
  "Input Notes":"Indtast en bemærkning",

  "Profile":"Profil",
  "Complications":"Komplikationer",
  "Concomitant diseases":"Samtidige sygdomme",
  "Suggestion":"Suggestions",   // todo
  "Coronary heart disease":"Koronar hjertesygdom",
  "High blood lipids":"Forhøjede lipider i blodet",
  "High blood pressure":"Højt blodtryk",
  "Kidney disease":"Nyresygdom",
  "Neuropathy":"Neuropati",
  "Obesity":"Overvægt",
  "Peripheral arterial disease":"Perifer arteriesygdom",
  "Retinopathy":"Retinopati",
  "Smoking addiction":"Tobaksafhængighed",
  "Enter date":"Indtast dato",
  "Enter suggestion":"Indtast forslag",
  "Enter Notes":"Enter Notes",   // todo
  "Select":"Vælg",
  "Prescription":"Recept",
  "Medicine":"Medicin",
  "Dose":"Dosis",
  "Enter medicine":"Indtast medicin",
  "Enter dose":"Indtast dosis",
  "Enterdis":"Enter concomitant diseases",   // todo
  "Add note":"Tilføj bemærkning",
  "Add Content":"Maximum 1000 tegn.",
  "Other suggestions":"Andre forslag",
  "OK":"OK",
  "HCP":"Sundhedsperson",
  "Content":"Indhold",
  "Records Report":"Overbliks Rapport ",

  "Quick Print":"Hurtig udskrivning",
  "Quick Print Settings":"Indstillinger for hurtig udskrivning",
  "Select duration":"Vælg varighed: ",   // todox
  "One Week":"En uge",
  "One Month":"En måned",
  "One Quarter":"Et kvartal",
  "End date":"Slutdato:",   // todox
  "Yesterday":"I går",
  "Last Sunday":"Sidste søndag",
  "Last Saturday":"Sidste lørdag",
  "Last Day of Last Month":"Last Day of Last Month",   // todo
  "Last Day of Last Quarter":"Last Day of Last Quarter",   // todo
  "Customized":"Tilpas",
  "Week Filter":"Ugefilter",
  "Select reports to print":"Vælg rapporter, der skal udskrives",
  "Daily Summary":"Daglig Oversigt",
  "Day By Day Overview":"Oversigt dag for dag",
  "Sensor Overlay":"Sensoroverblik",
  "Trend Analysis":"Tendens Analyse",
  "Logbook":"Logbog",
  "Device Settings Review":"Gennemgang af Enheds indstillinger",
  "createReport":"Opret rapport",

  "Segment Analysis":"Segment Analyse",
  "Sensor Glucose Profile":"Sensorglucose Profil",
  "# of Boluses":"Antal bolusser",
  "Bolus Insulin":"Bolusinsulin ",   // todox
  "Basal Pattern":"Basalmønster ",   // todox
  "Segment Analysis Report":"Segment Analyse",
  "Avg Glucose":"Gns. glukose",   // todox
  "Below":"Under",   // todox
  "In Target Range":"Inden for målområde",
  "Coefficient of variation":"Variationskoefficient ",
  "% Time CGM Active":"% tid med aktiv CGM",
  "est_a1c_t1":"Anslået A1C",   // todox
  "est_a1c_t2":"beregnet ud fra SG-værdier",   // todox
  "est_a1c_t3":"Bemærk: Anslået A1C erstatter Ikke tilgængelig",

  "acceptTip":" har tilladt, at du følger vedkommendes sundhedsoplysninger. ",   // todox
  "cancelTip":" tillader ikke længere at du følger vedkommendes sundhedsoplysninger. Du kan om nødvendigt ansøge igen.",   // todox
  "rejectTip":" har afvist din ansøgning om at følge data.",   // todox
  "Read":"Læs",

  "Connection":"Forbindelse",
  "connections1":"Forbindelser",
  "Add Connection":"Tilføj forbindelse",
  "SG":"SG",
  "Active Insulin":"Aktivt insulin",
  "Stop following":"Stop med at følge",
  "Enter username (email)":"Indtast brugernavn (e-mail)",
  "Search results":"Søgeresultater",
  "Send request":"Send anmodning",
  "View graphs":"Vis grafer",
  "Agree":"Acceptér",
  "Deny":"Afvis",
  "Remove":"Fjern",
  "Cancel Requset":"Annuller anmodning",
  "Remark":"Bemærkning",

  "Warm up":"Opvarmning",
  "Monitoring":"Overvågning",
  "Transmitter Error":"Transmitterfejl",
  "Sensor Failure":"Sensorfejl",
  "Sensor Expired":"Sensor udløbet",
  "Lost Sensor":"Tabt sensor",
  "Not Calibrated":"Ikke kalibreret",
  "Calibrating":"Kalibrerer",
  "Calibration Needed":"Kalibrering nødvendig",
  "Calibration Error":"Kalibreringsfejl",
  "Charging Battery":"Oplader batteri",
  "Battery Charged":"Batteri opladet",

  "To be filled":"Skal fyldes",
  "Filled with insulin":"Fyldt med insulin",
  "Priming":"Priming",
  "Priming completed":"Priming er fuldført",
  "Inserting needle":"Isæt nål",
  "Patch activated":"Patch aktiveret",
  "Delivering Basal":"Tilfører basal",
  "Exceeds Max 1 Hour Delivery":"Overstiger maks. tilførsel pr. 1 time",
  "Exceeds Max TDD":"Overstiger maks. TDD",
  "Suspend":"Stop af tilførsel",
  "Occlusion Detected":"Okklusion registreret",
  "Patch Expired":"Patch udløbet",
  "Empty Reservoir":"Tomt reservoir",
  "Patch Error":"Patch-fejl",
  "Pump Base Error":"Pumpebase Fejl",
  "Patch Battery Depleted":"Patch-batteri afladet",
  "Magnetic sensor not calibrated":"Magnetisk sensor ikke kalibreret",

  "Patient Profile":"Patient Profil",

  "On":"Til",
  "on":"Start",
  "Off":"Fra",
  "off":"Til",

  "CORONARY_HEART_DISEASE":"Koronar hjertesygdom",
  "HIGH_BLOOD_LIPIDS":"Forhøjede lipider i blodet",
  "HIGH_BLOOD_PRESSURE":"Højt blodtryk",
  "KIDNEY_DISEASE":"Nyresygdom",
  "NEUROPATHY":"Neuropati",
  "OBESITY":"Overvægt",
  "PERIPHERAL_ARTERIAL_DISEASE":"Perifer arteriesygdom",
  "RETINOPATHY":"Retinopati",
  "SMOKING_ADDICTION":"Tobaksafhængighed",

  "saveTip":"Gemt korrekt.",
  "changePaTip":"Din adgangskode er blevet ændret.",
  "enterEmTip":"Indtast din e-mailadresse.",
  "verErrTip":"Bekræftelseskode er forkert.",
  "chooseEventTip":"Vælg begivenheder, der skal udskrives",
  "chooseDataTip":"Vælg data til print",
  "dateWrongTip":"Slutdatoen kan ikke ligge tidligere end startdatoen.",
  "infoWrongTip":"Udfyld alle obligatoriske felter.",
  "createdSuccssTip":"Oprettet med succes",
  "selectData":"Vælg data der skal gemmes",

  "acceSu":"Accpter anmodning",
  "acceEr":"Kunne ikke tilføje ny forbindelse",
  "rejeSu":"Afvist anmodning",
  "rejeEr":"Kunne ikke afvise anmodning",

  "userNotExist":"Brugernavn findes ikke.",
  "Password incorrect":"Forkert adgangskode.",
  "UserType incorrect":"Forkert Brugertype",

  "registSuccess":"Din Konto er oprettet med succes.",
  "registFailed":"Kunne ikke registrere en ny Konto.",
  "sentSuccess":"Meddelelse er sendt",
  "sentFailed":"Meddelelse blev ikke sendt",
  "Input error":"Input Fejl ",

  "deletePtip":"Er du sikker på, at du vil slette disse patienter?",
  "deleteEvents":"Er du sikker på, at du vil slette disse hændelser?",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",   // todo
  "deleteThis":"Er du sikker på, at du vil slette?",
  "confirm":"Bekræft",
  "deleteSuccess":"Slettet",
  "deleteFailed":"Element blev ikke slettet",
  "modifySuccess":"Ændret med succes",
  "modifyFailed":"Ændring mislykkedes",
  "createSuccess":"Oprettet med succes",
  "createFailed":"Kunne ikke oprette",
  "editSuccess":"Redigering gennemført",
  "editFailed":"Kunne ikke redigere",
  "Time overlapped":"Sessionerne du har valgt, overlapper hinanden.",

  "stopFollow":"Er du sikker på, at du ikke længere vil følge denne patient?",
  "CancelTip1":"Er du sikker på, at du vil slette denne forbindelse?",

  "Warning":"Advarsel",
  "agreeConnect":"Hvis du trykker \"enig\" accepteres anmodningen, og dine data bliver tilgængelige for den nye forbindelse.",
  "denyConnect":"Er du sikker på, at du vil afvise denne anmodning?",
  "deleteConnect":"Er du sikker på, at du vil slette denne forbindelse? Hvis den slettes, vil forbindelsen ikke kunne følge dine data mere.",

  "Choose the events to print":"Choose the events to print",   // todo
  "tryAgain":"Prøv igen",
  "username and password is required":"username and password is required",   // todo
  "A name is required":"A name is required",   // todo
  "username is required":"Username is required",   // todo
  "The date choose wrong":"Fejl i datovalg",
  "Date no more than 14 days":"Du kan ikke vælge mere end 14 dage.",

  "CancelTip":"Er du sikker på at du vil slette denne forbindelse?",
  "removeConnect":"Slettet",

  "dateErr1":"Du kan ikke vælge mere end 90 dage.",
  "dateErr2":"Slutdatoen kan ikke ligge tidligere end startdatoen.",

  "Not Filled":"Ikke angivet",
  "Today":"I dag",
  "duration":"Varighed",
  "interval":"Interval",   // todo
  "7 days":"7 dage",
  "14 days":"14 dage",
  "30 days":"30 dage",   // todo
  "90 days":"90 dage",   // todo
  "g":"g",   // todo

  "Sound+Vibrate":"Lyd + vibration",
  "Sound":"Lyd ", // update
  "Vibrate":"Vibration",
  "Silent":"Må ikke forstyrres",
  "1":"En enkelt gang", // update
  "2":"Dagligt",
  "noMes":"Der er ingen meddelelser.",   // todox
  "noConnect":"Der er ingen forbindelser.",   // todox
  "Customize":"Tilpas",
  "GB":"United Kingdom",   // todo
  "CN":"China",   // todo
  "FR":"France",   // todo
  "DD":"Germany",   // todo
  "DE":"Germany",   // todo
  "SE":"Sweden",   // todo
  "AU":"Australia",   // todo
  "HKF":"Hongkong",   // todo
  "HU":"Hungary",   // todo
  "IT":"Italy",   // todo
  "NL":"Netherlands",   // todo
  "Nor":"Norway",   // todo
  "PT":"Portugal",   // todo
  "ES":"Spain",   // todo
  "TR":"Turkey",   // todo

  "Jan":"Jan",   // todo
  "Feb":"Feb",   // todo
  "Mar":"Mar",   // todo
  "Apr":"Apr",   // todo
  "May":"May",   // todo
  "Jun":"Jun",   // todo
  "Jul":"Jul",   // todo
  "Aug":"Aug",   // todo
  "Sep":"Sep",   // todo
  "Oct":"Oct",   // todo
  "Nov":"Nov",   // todo
  "Dec":"Dec",   // todo
  "ApplyTip":" request to view your data.",   // todo
  "noReadings":"Ingen målinger",

  "daop_A6_system":"A6 Touchcare System",   // todo
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",   // todo
  "daop_TY012_TY015":"TY012/TY015",   // todo
  "daop_easysense":"EasySense",   // todo
  "daop_delete_data":"Slet Data",
  "daop_uploaded_data":"Overførte data",
  "daop_uploaded_data_text":"Dataene er fra EasyTouch-appen eller EasyView-appen til iPad.",
  "daop_realtime_data":"Realtidsdata",
  "daop_realtime_data_text":"The data is from EasySense App or EasyPatch App.",   // todo

  "ins_unit":"(IE) ",
  "ins_unit2":"IE",
  "basal_unit":"(IE/T) ",
  "basal_unit2":"IE/T",
  "dump_last":"Dump End",   // todo

  "Alerts_Patch_Battery_Low":"Patch-batteri lavt",
  "Alerts_Patch_Battery_Depleted":"Patch-batteri afladet", // update
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"Reservoir lavt", // update
  "Alerts_Empty_Reservoir":"Tomt reservoir",
  "Alerts_Patch_Expiration_Advisory":"Meddelelse om udløb af patch",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"Patch udløbet", // update
  "Alerts_Patch_Error":"Patch-fejl",
  "Alerts_Pump_Base_Error":"Pumpebase Fejl",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"Okklusion registreret", // update
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"Overstiger maks. TDD", // update
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"Overstiger maks. tilførsel pr. 1 time",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"Stop før Lav", // update
  "Alerts_Low_Suspend":"Stop ved Lav",
  "Alerts_Auto_Off":"Auto-sluk", // update

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Udenfor rækkevidde",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"Tabt sensor", // update
  "Alerts_Transmitter_Battery_Low":"Transmitterbatteri lavt",
  "Alerts_Charge_Transmitter":"Oplad transmitter",
  "Alerts_Sensor_Error":"Ingen målinger",
  "Alerts_Transmitter_Error":"Transmitterfejl",
  "Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"Sensorfejl",
  "Alerts_Sensor_Calibration_Reminder":"Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now":"Mål BS nu",
  "Alerts_Sensor_Exp_in_6_Hours":"Sensorudløb om 6 timer",
  "Alerts_Sensor_Exp_in_2_Hours":"Sensorudløb om 2 timer", // update
  "Alerts_Sensor_Exp_in_30_Min":"Sensorudløb om 30 min.",
  "Alerts_Sensor_Expired":"Sensor udløbet", // update
  "Alerts_Rapid_Rise":"Hurt. stig",
  "Alerts_Rapid_Fall":"Hurt. fald",
  "Alerts_High_Predicted":"Høj forventet",
  "Alerts_Low_Predicted":"Lav forventet",
  "Alerts_High_Glucose":"Høj glukose", // update
  "Alerts_Low_Glucose":"Lav glukose", // update
  "Alerts_Below_3.1_mmol/L":"Under 3,1 mmol/l",
  "Alerts_Transmitter_Battery_Low_2":"Transmitterbatteri lavt",

  "Alerts_PDM_Battery_Low":"PDM-batteri lavt",
  "Alerts_Replace_Battery":"Oplad PDM Nu",

  // Alert页面
  "Alert":"Alert",
  "Alerts":"Advarsler",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"Pumpe",
  //"CGM":"CGM",
  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode":"Tid i Auto Tilstand",
  "t1221_Average_SG_SD":"Gennemsnit SG ± SD",
  "t1221_Time_in_Target_Range":"Tid i Målområde",
  "t1221_Time_above_Range":"Tid over Målområde",
  "t1221_Time_below_Range":"Tid under Målområde",
  "t1221_Auto_Basal_per_day":"Auto Basal (pr dag)",
  "t1221_Auto_Bolus_per_day":"Auto Bolus (pr dag)",
  "t1221_Auto_Mode_Exits":"Auto Tilstand Afsluttet",
  "t1221_No_Sensor_readings":"Ingen Sensoraflæsninger",
  "t1221_Max_Delivery":"Max. Tilførsel",
  "t1221_Min_Delivery":"Min. Tilførsel",
  "t1222_autoModeBasal":"Auto Tilstand Basal",
  "t1222_autoModeCorrBolus":"Auto Tilstand Korrek. Bolus",
  "t1222_autoSnack":"Auto Snack",
  "t1222_autoBreakfast":"Auto Morgen",
  "t1222_autoLunch":"Auto Frokost",
  "t1222_autoDinner":"Auto Middag",
  "t1222_autoExercise":"Auto Træning",
  "t1222_Snack":"Snack",
  "t1222_Auto_Mode":"Auto Tilstand",
  "t1222_Time_in_Auto_Mode":"Tid i Auto Tilstand (%)",
  "t1222_Avg_SD":"Gns(mmol/L)±SD",
  "t1222_Target_Range":"Målområde (%)",
  "t1222_Above_Range":"Over Målområde (%)",
  "t1222_Below_Range":"Under Målområde (%)",
  "t1222_Auto_Mode_Exits":"# af Auto Tilstand Afsluttet",
  "t1221_Auto_Mode":"Auto Tilstand",
  "t1222_auto_basal":"Auto Basal",
  "t1222_auto_bolus":"Auto Bolus",
  "t0805_User_Management":"Bruger Liste",
  "t0805_Patient_Management":"Patient Liste",
  "t0805_Operation_History":"Hændelses Historik",
  "t0805_User_List":"Brugerliste",
  "t0805_User":"Bruger",
  "t0805_Time":"Tid",
  "t0805_Operation_Type":"Operation Type",
  "t0805_Back":"Tilbage",
  "t0805_Add":"Tilføje",
  "t0805_Delete":"Slet",
  "t0809_Add_User":"Tilføj bruger",
  "t1028_Pattern_C":"Mønster C",
  "t1028_Pattern_D":"Mønster D",
  "t1029_Auto_meal_bolus":"Auto Måltid Bolus",
  "t1029_Auto_mode_correction_bolus":"Auto Tilstand Korrektions Bolus",
  "t1029_Sick":"Syg",
  "t1029_Auto_Mode_Feature":"Auto tilstand funkt.",
  "t1029_Target_SG":"SG Mål",
  "t1029_Auto_Meal_Handling":"Auto Måltid Behandling",
  "t1029_Total_Daily_Dose":"Total Daglig Dosis",
  "t1029_Pump_Light":"Pumpe Lys",
  "t1029_Alerts_for_Hypo":"Advarsel for Hypo",
  "t1102_Out_of_Range":"Udenfor rækkevidde",
  "t1102_Command_Reminder":"Kommando Påmindelse",
  "t1102_Alarms_Alerts_on_APP":"Alarmer & Advarsler på App",
  "t1102_Alarms_on_App":"Alarmer på App",
  "t1102_Alerts_on_App":"Advarsler på App",
  "t1102_Factory_Calibration":"Fabrik Kalibrering",
  "t1102_Alerts_for_Low":"Advarsler for Lav",
  "t1102_Alerts_for_High":"Advarsler for Høj",
  "t1102_Alerts_for_Others":"Advarsler for Andet",
  "t1102_Adjustment":"Justering",
  "t1102_Suggested":"Foreslag",
  "t1103_Glucose":"Glukose",
  "t1103_CGM":"CGM",
  "t1103_Insulin":"Insulin",
  "t1103_Carbs":"Kulhydrater",
  "t1103_Exercise":"Motion",
  "t1103_Min_Max":"Min/Max",
  "t1103_Target_Range":"Målområde",
  "t1103_Overall_Tine_In_Range":"Samlet: Tid i målområde",
  "t1103_Basal":"Basal",
  "t1103_Bolus":"Bolus",
  "t1103_Basal_Bolus":"Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range":"Auto Tilstand: Tid i målområde",
  "t1103_Time_below_range":"Tid under målområde",
  "t1103_Time_above_range":"Tid over målområde",
  "t1103_Time_in_target_range":"Tid i målområde",
  "t1103_Incorrect_Password":"Forkert adgangskode, $1 Forsøg tilbage, indtast venligst den korrekte adgangskode.",
  "t1103_Incorrect_locked":"Mislykkede forsøg overskrider grænsen, kontoen er blevet låst. Prøv venligst igen om $1 minutter.",
  "t1104_The_data_is_from":"Dataene er fra EasySense App eller EasyPatch App.",
  "t1104_Privacy_Policy":"Politik om databeskyttelse og vilkår for brug",
  "t1104_updated_privacy_policy":"Vi har opdateret vores politik om databeskyttelse og vilkår for brug . For at kunne fortsætte med at bruge Easyview, bedes du læse og acceptere alle vilkårene.",
  "t1104_Disagree":"Uenig",
  "t1104_Agree":"Acceptér",
  "t1105_Upload_History":"Overførsels Historik",
  "t1105_Delete_Data":"Slet data",
  "t1105_Target_Range":"Måleområde",
  "t1105_request_to_view_your_data":"$1 anmodning om at se dine data.",
  "t1105_Recent_Updates":"Seneste opdateringer",
  "t1108_No_data":"Ingen data",
  "t1108_Pump_Bash_SN":"Pumpebases SN",
  "t1108_Transmitter_SN":"Transmitters SN",
  "t1112_Normal_Glucose":"Normal Glukose",
  "t1112_Manual_Bolus_or_Modified_Bolus":"Manuel bolus eller ændret bolus",
  "t1112_Auto_Mode_Started":"Auto Tilstand Startet",
  "t1112_Auto_Mode_Exit":"Afslut Auto Tilstand",
  "t1112_Normal_Bolus":"Normal Bolus",
  "t1112_Extended_Bolus":"Forlænget Bolus",
  "t1112_Combo_Bolus":"Kombi. bolus",
  "t1112_Carbs":"Kulhydrater",
  "t1112_Glucose":"Glukose",
  "t1112_BG":"BS",
  "t1112_Audio":"Lyd",
  "t1112_Tone":"Tone",
  "t1112_Audio_Options":"Lyd Indstillinger",
  "t1112_Weight_Unit":"Vægtenhed",
  "t1112_Height_Unit":"Højdeenhed",
  "t1112_Not_available":"Ikke Tilgængelig",
  "t1112_Number":"Nummer",
  "t1112_days":"# dage",
  "t1112_min":"min.",
  "t1113_days":"dage",
  "t1215_Security":"Sikkerhed",
  "t1215_MFA":"Multi-faktor autentificering (MFA)",
  "t1215_Enter_verification_code":"Indsæt verifikations kode",
  "t1215_Multi_factor_ON":"Multifaktorgodkendelse er TIL. Bekræftelseskoden er blevet sendt til $1 Indsend venligst bekræftelseskode.",
  "t1215_Verification_code_incorrect":"Bekræftelseskode er forkert",
  "t1215_Show_Glucose_Value":"Vis glukoseværdi",
  "t1221_enter_verification_code":"Indtast venligst den 6-cifrede bekræftelseskode sendt til $1.",
  "t1221_Verification_Success":"Bekræftet med succes",
  "t1222_We_will_only_process":"Vi behandler kun dine Sundhedsdata via Medtrums app/websted med dit samtykke. ",
  "t1222_If_you_are_under_years":"Hvis du er under 16 år, skal du have tilladelse fra en forælder eller værge til at registrere dig i denne app.",
  "t1221_register_cn":"Du har ret til ikke at overføre nogen enhedsdata til appen, og i så fald vil dataene ikke være tilgængelige for andre. Hvis du vælger ikke at registrere dig i Medtrums app/websted, er den eneste fortegnelse over dine sundhedsdata på selve enheden. ",
  "t1221_register_eu":"Hvis du vælger at registrere din Medtrum-konto og få adgang til vores app ved hjælp af kontoen, vil de sundhedsdata, der er registreret i appen, blive overført til vores server i Europa og opbevaret i 2 år. Du har ret til ikke at overføre nogen enhedsdata til appen, og i så fald vil dataene ikke være tilgængelige for andre. Hvis du vælger ikke at registrere dig i Medtrums app/websted, er den eneste fortegnelse over dine sundhedsdata på selve enheden.",
  "t1221_register_follow":"Vi behandler kun dine sundhedsdata via Medtrums app/websted med dit samtykke.",
  "t1222_Terms_of_Use":"Medtrums vilkår for brug",
  "t1222_Privacy_Policy":"Medtrums politik om databeskyttelse",
  "t1222_Create_Account":"Opret konto",
  "t1222_Back":"Tilbage",
  "t1222_Verify_your_account":"Bekræft din konto",
  "t1222_please_check_your_account":"Vi sender en bekræftelseskode til $1, Tjek venligst din konto.",
  "t1222_I_Agree_to":"Jeg accepterer $1",
  "t1223_Invalid_Verification_Code":"Ugyldig bekræftelseskode. Prøv igen.",
}

//export  default  {
//  dkMessages
//}



// WEBPACK FOOTER //
// ./src/lang/dk.js